export default __webpack_public_path__ + "static/og-image-14f3a26178ee069f516a2288cabd20b3.png";